<template>
    <AppModal :title="$t('labels.copy_products_result_title')" ref="modal" @on-hide="hide">
        <div class="modal-body">
            <p>{{ $t('labels.copy_products_result_created', { count: created }) }}</p>
            <div class="table-responsive table-scrollable" v-if="skipped.length > 0">
                <table class="table table-bordered table-fixed">
                    <thead>
                        <tr>
                            <th>{{ $t('labels.sku') }}</th>
                            <th>{{ $t('labels.copy_products_result_reason') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in skipped" :key="index">
                            <td>{{ item.sku ?? '—' }}</td>
                            <td>{{ $t(`skipReasons.${item.reason}`) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../components/new/modal/AppModal.vue';

export default {
    name: "CreateIntegrationProductsResultModal",
    components: { AppModal },
    data() {
        return {
            created: 0,
            skipped: []
        };
    },
    methods: {
        show({ created, skipped }) {
            this.created = created;
            this.skipped = skipped ?? [];
            this.$refs.modal.show();
        },
        hide() {
            this.$refs.modal.hide();
            this.created = 0;
            this.skipped = [];
        }
    }
}
</script>
